export enum PATH {
  HOME = '/',
  EXAMPLE = '/examples/:module/:example',
  EMBED = '/embed/:module/:example'
}
